/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';


import { environment } from './../../environments/environment';
import { NgdAppComponent } from './app/app.component';
import { NbAuthModule, NbPasswordAuthStrategy } from '../../app/authentication/auth.module';
import { HttpLoaderFactory } from '../../app/utils/translationLoader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { routes } from './app/app.routes';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { NgdThemeModule } from './app/@theme/theme.module';
import { NbSidebarModule, NbCardModule, NbLayoutModule, NbTabsetModule, NbCheckboxModule, NbMenuModule, NbThemeModule, NbDialogModule, NbToastrModule, NbWindowModule } from '@nebular/theme';
import { withInterceptorsFromDi, provideHttpClient, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ChunkLoadErrorHandler, isChunkLoadError, NavigationHelpers, reloadForChunkError } from '../../app/common/utils';
import { StateService } from '../../app/@core/utils/state.service';
import { ApiService } from '../../app/services/api/api.service';
import { structure } from './structure';
import { STRUCTURE, DOCS } from './app/app.options';
import { Title, REMOVE_STYLES_ON_COMPONENT_DESTROY, BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { de } from 'date-fns/locale';
import { NbDatepickerModule } from '@nebular/theme';
import { installDevConsole } from '../../app/@core/utils/dev-console';

installDevConsole();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(NgdAppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, FormsModule, NbSidebarModule, NbCardModule, NbLayoutModule, NbTabsetModule, NbCheckboxModule, NbMenuModule.forRoot(), NbThemeModule.forRoot(), NgdThemeModule.forRoot(), NbSidebarModule.forRoot(), NbDialogModule.forRoot(), NbToastrModule.forRoot(), 
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
         NbWindowModule.forRoot(),
         NbAuthModule.forRoot({
            strategies: [
                NbPasswordAuthStrategy.setup({
                    name: 'email',
                    baseEndpoint: environment.apiUrl,
                    login: {
                        endpoint: 'api/auth/local',
                        method: 'post',
                    }
                }),
            ],
            forms: {},
        }), 
        NbDatepickerModule.forRoot(),
        NbDateFnsDateModule.forRoot({
          parseOptions: { locale: de, useAdditionalWeekYearTokens: true, useAdditionalDayOfYearTokens: true },
          formatOptions: { locale: de, useAdditionalWeekYearTokens: true, useAdditionalDayOfYearTokens: true },
        })),
        Title,
        { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
        { provide: STRUCTURE, useValue: structure },
        { provide: DOCS, useValue: { classes: [], themes: {} } },
        {
            provide: REMOVE_STYLES_ON_COMPONENT_DESTROY,
            useValue: false,
        },
        // Services from main project
        ApiService,
        StateService,
        NavigationHelpers,
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter(routes, withNavigationErrorHandler((error: any) => {
            if (isChunkLoadError(error)) {
                reloadForChunkError();
            }
        })),
    ]
});

